<template>
  <v-container fluid>
    <v-row>
      <v-col class="position-relative">
        <a :href="app.url" target="_blank"
          ><img src="@/assets/logo_black.png" height="70px"
        /></a>
        <h1 class="thin mt-5">
          Create your account
        </h1>
        <h3 class="thin mb-4">
          Already have an account ? <a href="/signin">Login</a>
        </h3>
        <h3 class="thin my3">
          Invited by {{ invited_by.name }} from {{ invited_by.company }}
        </h3>
        <form>
          <v-row>
            <!-- company name field END -->
            <!-- email field START -->
            <v-col cols="12" class="pb-0">
              <v-text-field
                label="Email"
                :error-messages="errors.email"
                disabled
                required
                :value="value.email"
              />
            </v-col>
            <!-- email field END -->
            <!-- <v-col cols="12" class="py-0">
              <v-text-field
                v-model="$v.signupForm.username.$model"
                :error-messages="errors.username"
                label="Nom d'utilisateur"
                required
                @input="updateForm"
              />
            </v-col> -->
            <!-- first name field START -->
            <v-col class="pr-2 py-0" cols="6">
              <v-text-field
                v-model="$v.signupForm.first_name.$model"
                :error-messages="errors.first_name"
                label="First name"
                class="input-group--focused"
                required
                @input="updateForm"
              />
            </v-col>
            <!-- first name field END -->
            <!-- last name field START -->
            <v-col class="pl-2 py-0" cols="6">
              <v-text-field
                v-model="$v.signupForm.last_name.$model"
                :error-messages="errors.last_name"
                label="Last name"
                required
                @input="updateForm"
              />
            </v-col>
            <!-- last name field END -->
            <!-- password field START -->
            <v-col cols="12" class="py-0">
              <v-text-field
                type="password"
                v-model="$v.signupForm.password.$model"
                :error-messages="errors.password"
                placeholder="Enter your password"
                @input="updateForm"
              />
            </v-col>
            <v-col cols="12" class="py-0">
              <v-text-field
                type="password"
                v-model="$v.signupForm.password2.$model"
                :error-messages="errors.password2"
                placeholder="Repeat password"
                @input="updateForm"
              />
            </v-col>
            <!-- password field END -->
            <!-- sign up button START -->
            <v-col cols="12" class="text-center">
              <v-btn
                large
                :loading="loading"
                :disabled="canSubmit"
                color="primary"
                block
                @click="submit"
              >
                Sign up
              </v-btn>
            </v-col>
            <!-- sign up button END -->
          </v-row>
        </form>
        <!-- form END -->
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { CompanyService, AccountService, BrandService } from "@/services"
import vuelidate from "vuelidate"
import { validationMixin } from "vuelidate"
import {
  required,
  url,
  numeric,
  alpha,
  sameAs,
  minLength
} from "vuelidate/lib/validators"
export default {
  mixins: [validationMixin],
  validations: {
    signupForm: {
      email: { required },
      // username: { required },
      first_name: {},
      last_name: {},
      password: {
        required,
        minLength: minLength(8)
      },
      password2: {
        required,
        minLength: minLength(8),
        sameAsP1: sameAs(function() {
          return this.signupForm.password
        })
      }
    }
  },
  data() {
    return {
      app: {
        name: "Perfumist",
        url: "https://perfumist.fr"
      },
      signupForm: {
        email: "",
        // username: "",
        first_name: "",
        last_name: "",
        password: "",
        password2: "",
        merchant: ""
      },
      loading: false
    }
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          email: "",
          // username: "",
          first_name: "",
          last_name: "",
          password: "",
          password2: "",
          merchant: ""
        }
      }
    },
    invitation_key: {
      type: String,
      default: ""
    },
    invited_by: {
      type: Object,
      default: () => {
        return { name: "", company: "" }
      }
    },
    user_pk: {
      type: Number,
      default: -1
    }
  },
  computed: {
    errors() {
      const errors = {
        email: [],
        // username: [],
        first_name: [],
        last_name: [],
        password: [],
        password2: []
      }

      this.$v.signupForm.email.$dirty &&
        !this.$v.signupForm.email.required &&
        errors.email.push("Email is required")

      // this.$v.signupForm.username.$dirty &&
      //   !this.$v.signupForm.username.required &&
      //   errors.username.push("Le nom d'utilisateur est requis")

      this.$v.signupForm.password.$dirty &&
        !this.$v.signupForm.password.required &&
        errors.password.push("Password is required")

      this.$v.signupForm.password2.$dirty &&
        !this.$v.signupForm.password2.required &&
        errors.password2.push("Repeat password is required")

      this.$v.signupForm.password.$dirty &&
        !this.$v.signupForm.password.minLength &&
        errors.password.push("The password must be at least 8 characters long")

      this.$v.signupForm.password2.$dirty &&
        !this.$v.signupForm.password2.minLength &&
        errors.password2.push(
          "The repeat password must be at least 8 characters long"
        )

      this.$v.signupForm.password2.$dirty &&
        !this.$v.signupForm.password2.sameAsP1 &&
        errors.password2.push("Password and repeat password are not the same")

      return errors
    },
    canSubmit() {
      return this.$v.signupForm.$invalid || this.loading
    }
  },
  methods: {
    setSignupForm(v) {
      this.signupForm.email = v.email
      this.signupForm.username = v.email
      this.signupForm.first_name = v.first_name
      this.signupForm.last_name = v.last_name
      this.signupForm.password = v.password
      this.signupForm.password2 = v.password2
      this.signupForm.merchant = v.merchant
    },
    getBrands() {
      this.isLoading = true

      BrandService.all(this)
        .then(result => {
          this.$store.commit("setBrands", result)
          this.$store.commit("setGlobalBrand", result)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    call_login(email, password) {
      AccountService.login(this, { email, password }, { name: "Accueil" }).then(
        r => {
          this.getBrands()
        }
      )
    },
    submit() {
      //Update de l'user
      if (!this.$v.signupForm.$invalid && this.user_pk >= 0) {
        // Update user if it work accept the invitation
        this.loading = true
        CompanyService.update_by_invitation(
          this,
          this.signupForm,
          this.user_pk,
          this.invitation_key
        )
          .then(result => {
            this.$store.commit("success", "Your account has been created")

            // setTimeout(() => {
            //   this.$router.replace("/signin")
            // }, 1500)
            this.call_login(this.signupForm.email, this.signupForm.password)
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => {
            this.loading = false
          })
        // console.log(this.signupForm);
      }
    },
    updateForm() {
      this.$emit("input", this.signupForm)
    }
  },
  watch: {
    value: {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue) this.setSignupForm(newValue)
      }
    }
  },
  mounted() {}
}
</script>

<style>
.bg-cover {
  background-color: #ff505c;
  background-position: 50% 50%;
  background-image: url(../../assets/signin_cover.png);
}
.pa-7 {
  padding: 70px;
}

.thin {
  font-weight: 300;
}

@media only screen and (max-width: 450px) {
  .pa-7 {
    padding: 35px;
  }
}
</style>
